import { IconPaperBag } from '@tabler/icons-react';
import useModules from '@utils/hooks/useModules';

type OrdersCounterProps = {
  isDesktop: boolean;
  current: number | null | undefined;
  limit: number | null | undefined;
  usagePercent: number | null | undefined;
};

export const OrdersCounter = ({ isDesktop, current, limit, usagePercent: percent }: OrdersCounterProps) => {
  // Validación defensiva para evitar errores con valores null/undefined
  const safeCurrent = current ?? 0;
  const safeLimit = limit ?? 0;
  const safePercent = percent ?? 0;
  const { hasModule } = useModules();
  const color =
    safePercent >= 90 ? '#FF3939' : safePercent >= 75 ? '#FF7800' : safePercent >= 50 ? '#FD9900' : '#04AF00';
  const isByConsumption = hasModule('POR_CONSUMO');

  return (
    <section className="bg-color-white text-color-primary_dark px-[10px] py-[6px] rounded-[6px] flex items-center">
      <div className="flex items center gap-1">
        <span className="flex items-center">
          <IconPaperBag width={24} height={24} />
        </span>
        <div className="flex items-center flex-col gap-[1px]">
          <div className="flex">
            {isByConsumption ? (
              <p>
                {isDesktop ? 'Pedidos: ' : ''}
                <span className="font-semibold">{safeCurrent.toLocaleString('es-MX')}</span>
                {' de '}
                <span className="font-semibold">{safeLimit.toLocaleString('es-MX')}</span>
              </p>
            ) : (
              <p style={{ fontSize: isDesktop ? '16px' : '12px' }}>
                <span className="font-semibold"> {safeCurrent.toLocaleString('es-MX')} </span>
                Pedidos en el mes
              </p>
            )}
          </div>
          {isByConsumption ? (
            <div className="w-full relative h-[5px]">
              <div
                className="h-[3px] rounded-[3px] absolute z-10"
                style={{ backgroundColor: color, width: safePercent + '%' }}
              ></div>
              <div className="bg-color-gray-light w-full h-[3px] rounded-[3px] absolute"></div>
            </div>
          ) : null}
        </div>
      </div>
    </section>
  );
};
